import React from "react";
import MovimientoBase, { MovimientoBaseConfig } from "./MovimientoBase";

const config: MovimientoBaseConfig = {
  documentTitle: "Stock - Remisiones | Saas",
  breadcrumbTitle: "Remisión",
  breadcrumbSection: "Movimientos",
  breadcrumbSectionLink: "/stock/remisiones",
  breadcrumbDescription: "Gestión y seguimiento de remisiones de stock",
  conceptoTitulo: "Remisión",
  conceptoValor: "Remisión",
  apiPath: "/api/stock/remisiones",
  requiereTalonario: true,
  documentoTipo: "remision",
};

const StockRemisionesPage: React.FC = () => <MovimientoBase config={config} />;

export default StockRemisionesPage;
